import { render, staticRenderFns } from "./ProductDeliveryDatePopupIframe.vue?vue&type=template&id=4da5df23&"
import script from "./ProductDeliveryDatePopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductDeliveryDatePopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports